import { useNavigate, useLocation } from "react-router";
import { Button } from "primereact/button";
import { Icons } from './Icons/Icons';
import { JournalViewModel } from "../../../ViewModel/JournalViewModel";
import { useEffect, useState } from "react";
import React from "react";
import { RecapStatus } from "../../../Services/DataService/Model/RecapEntry";
import { RecapEntriesViewModel } from "../../../ViewModel";
import { addLocale } from 'primereact/api';
import { GLCalendar } from "./GLCalendar";

addLocale('custom', {
    firstDayOfWeek: 0, // Monday as the first day of the week
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // 3-character abbreviations
    dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // 3-character abbreviations
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear'
});



export function NavBar({ }: { journalViewModel: JournalViewModel }) {

    const { pathname } = useLocation();
    const [recapsDisabled, setRecapsDisabled] = React.useState<boolean>(false);
    const [calendarVisible, setVisible] = useState(false);
    const navigate = useNavigate();
    var navRoute: 'daily' | 'home' | 'settings' | 'recaps' | 'trends' | undefined = undefined;

    useEffect(() => {

        RecapEntriesViewModel.PropertyChanged.Subscribe((e) => {
            if (e.property === 'Recaps' || e.property === 'isHydrated')
                getEntries();
        });

        const getEntries = async () => {
            var entries = RecapEntriesViewModel.DisplayRecaps;
            let completedRecaps = entries.filter((entry) => entry.TypedData.status === RecapStatus.Complete);
            setRecapsDisabled(completedRecaps.length === 0);
        };
        RecapEntriesViewModel.RecapsChanged.Subscribe(() => getEntries);

        getEntries();

        return () => {
            RecapEntriesViewModel.RecapsChanged.Unsubscribe(() => getEntries);
        };
    }, []);


    //
    //
    //
    if (pathname.indexOf('home') >= 0)
        navRoute = 'home';
    else if (pathname.indexOf('daily') >= 0)
        navRoute = 'daily';
    else if (pathname.indexOf('recap') >= 0)
        navRoute = 'recaps';
    else if (pathname.indexOf('recapEntry') >= 0)
        navRoute = 'recaps';
    else if (pathname.indexOf('trends') >= 0)
        navRoute = 'trends';
    else if (pathname.indexOf('settings') >= 0)
        navRoute = 'settings';
    else
        console.warn(`NavBar: Unknown route: ${pathname}`);






    return (
        <div className="flex-none">
            <div className="gl-journal-nav flex flex-row justify-content-around">
                <Button
                    className="gl-navbutton gl-home-navButton"
                    raised
                    rounded
                    onClick={() => { navigate("./home") }}>
                    <div className="gl-button-content">
                        {navRoute === 'home' ? <Icons.HomeActiveIcon /> : <Icons.HomeIcon />}
                        <p>Home</p>
                    </div>
                </Button>
                <Button
                    className="gl-navbutton"
                    raised
                    rounded
                    onClick={() => { setVisible(true) }}>
                    <div className="gl-button-content">
                        {navRoute === 'daily' ? <Icons.JournalActiveIcon /> : <Icons.JournalIcon />}
                        <p>Entries</p>
                    </div>
                </Button>

                <Button
                    className="gl-navbutton"
                    raised
                    rounded
                    onClick={() => { navigate("./trends") }}
                >
                    <div className="gl-button-content">
                        {navRoute === 'trends' ? <Icons.TrendActiveIcon /> : <Icons.TrendIcon />}
                        <p>Trends</p>
                    </div>
                </Button>

                {
                    !recapsDisabled &&
                    <Button
                        className="gl-navbutton"
                        raised
                        rounded
                        onClick={() => { navigate("./recap") }}
                    >
                        <div className="gl-button-content">
                            {navRoute === 'recaps' ? <Icons.RecapsActiveIcon /> : <Icons.RecapsIcon />}
                            <p>Recaps</p>
                        </div>
                    </Button>
                }

                <Button
                    className="gl-navbutton"
                    raised
                    rounded
                    onClick={() => { navigate("./settings") }}
                >
                    <div className="gl-button-content">
                        {navRoute === 'settings' ? <Icons.SettingsActiveIcon /> : <Icons.SettingsIcon />}
                        <p>Settings</p>
                    </div>
                </Button>

            </div>
            <GLCalendar
                show={calendarVisible}
                onHideCallback={() => setVisible(false)}
            />
        </div>
    );
}